import {ElasticValidation, ElasticValidator} from '../validator.factory';
import {numberGtRegExp, numberLtRegExp, numberRangeRegExp, numberRegExp} from '../../paser/parsers/number.parser';

export class NumberValidator implements ElasticValidator {
  validate(numberString: string): ElasticValidation {
    if (numberString === undefined || numberString === null || numberString === '') {
      return {isInvalid: false};
    }

    numberString = numberString.trim();
    if (numberString === '') {
      return {isInvalid: true, errorMessage: `blanks are not allowed`};
    }

    const numberChunks = numberString.split('|')
      .map(numberChunk => numberChunk.trim())
      .filter(numberChunk => !!numberChunk);

    for (const numberChunk of numberChunks) {
      if (!numberRegExp.test(numberChunk) && !numberGtRegExp.test(numberChunk) && !numberLtRegExp.test(numberChunk) && !numberRangeRegExp.test(numberChunk)) {
        return {isInvalid: true, errorMessage: `${numberChunk} is not a valid numeric format`};
      }

      if (numberRangeRegExp.test(numberChunk)) {
        const match = numberRangeRegExp.exec(numberChunk);

        const numberFromString = match?.length > 0 && match[1];
        const numberToString = match?.length > 0 && match[6];

        if (+numberFromString > +numberToString) {
          return {isInvalid: true, errorMessage: `${numberFromString} is after ${numberToString}`};
        }
      }
    }

    return {isInvalid: false};
  }
}
